<template>
    <v-list
        dense
        nav
    >
        <v-list-item-group
            v-model="selectedItem"
            color="white"
        > 
           
            <div v-for="(item, i) in menuPermissions" :key="i">
                <v-list-item
                    @click="display(item)"                                    
                >
                    <v-list-item-icon v-if="item.visible">
                        <v-icon>
                            {{ item.icon }}
                        </v-icon>
                    </v-list-item-icon>
    
                    <v-list-item-content v-if="item.visible">
                        <v-list-item-title>
                            {{ item.text }}
                        </v-list-item-title>
                    </v-list-item-content>
    
                </v-list-item>
            </div>

        </v-list-item-group>                
    </v-list>                 
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
    name: 'AdminNavigation',

    created: function () {
        this.initialize();
    },

    computed: {
        ...mapGetters({
            menuOptions: 'admin/getMenuOptions',
            userAdmin: 'admin/getUserAdmin',
            adminPermissions: 'auth/getAdminPermissions',
            deanFormClasses: 'auth/getDeanFormClasses',
        })
    },

    data: () => ({        
        items: [
            { text: 'Dashboard', icon: 'mdi-view-dashboard', submenu: false, menu: 'dashboard', visible: true },            
            { text: 'Teachers', icon: 'mdi-account-group', submenu: false, menu: 'employees', visible: true },            
            { text: 'Students', icon: 'mdi-account-group', submenu: false, menu: 'students', visible: true },            
            { text: 'Subjects', icon: 'mdi-library', submenu: false, menu: 'studentSubjects', visible: true },            
            { text: 'Post Term Reports', icon: 'mdi-post', submenu: false, menu: 'postReports', visible: true },            
            { text: 'Edit\\View Term Details', icon: 'mdi-file-document-edit-outline', submenu: false, menu: 'termReports', visible: true },
            { text: 'Enter Marks', icon: 'mdi-keyboard', submenu: false, menu: 'enterMarks', visible: true },
            { text: 'Mark Book', icon: 'mdi-notebook', submenu: true, menu: 'courseMark', visible: true, disabled: false},
            { text: 'Reports', icon: 'mdi-file-cabinet', submenu: true, menu: 'reports', visible: true},    
            { text: 'Student Attendance', icon: 'mdi-bell', submenu: false, menu: 'attendanceStudent', visible: true},                  
        ],        
        selectedItem: 0,
        menuPermissions: [],       
    }),
    
    methods: {
        ...mapActions({
            registrationData: 'admin/downloadRegistrationData',
            currentPeriod: 'termReports/getCurrentAcademicPeriod',
            getFormClasses: 'admin/getFormClasses',
        }),

        ...mapMutations({
            setMenuOptions: 'admin/setMenuOptions',
            setEditTermReports: 'admin/setEditTermReports',
            setProgressOverlay: 'admin/setProgressOverlay',
        }),

        async initialize () {
            this.setProgressOverlay(true);
            let hasUpperForm = false;
            const deanFormClasses = JSON.parse(this.deanFormClasses);
            
            let menuOptions = {};
            const permissions = JSON.parse(this.adminPermissions);
            try {
                const [
                    { data: dataFormClasses}
                ] = await Promise.all([
                    this.getFormClasses(),
                    this.currentPeriod()
                ])

                const formLevels = [
                    ...new Set(
                        dataFormClasses.filter(value => deanFormClasses.includes(value.id)).map(item => item.form_level)
                    )
                ]

                hasUpperForm = formLevels.some(level => level > 3);

                console.log('hasUpperForm', hasUpperForm);
                
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
            }
            
            this.items.forEach( value => {
               menuOptions[value.menu] = false;

                permissions.forEach(permission => {
                    if(permission.menu == 'studentSubjects' && !hasUpperForm && this.userAdmin != 'Admin'){
                        // If the user is a dean and does not have any upper form classes, hide the studentSubjects menu
                    }
                    else if(permission.menu == value.menu){
                        this.menuPermissions.push(value)
                    }

                    if(permission.action == 'editTermReports') {
                        this.setEditTermReports(true);
                    }
                })

            })

            this.setMenuOptions(menuOptions);  
            
            setTimeout(() => {
                if(this.menuPermissions.length > 0) this.menuOptions[this.menuPermissions[0].menu] = true;
            }, 400)

            this.setProgressOverlay(false);
        },

        display(item){
            Object.keys(this.menuOptions).forEach(key => {
                this.menuOptions[key] = false;
            })
            this.menuOptions[item.menu] = true;
        },
       
    }
}
</script>

<style scoped>
    ::v-deep .v-list-item__title{
        white-space: pre-wrap;
    }
</style>